/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Earth_Day_2025_Donate_Plan_NoteInputs */

const en_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can only contribute once`)
};

const ar_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنك المساهمة مرة واحدة فقط`)
};

const de_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie können nur einmal beitragen`)
};

const es_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sólo puedes contribuir una vez`)
};

const fr_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous ne pouvez contribuer qu'une seule fois`)
};

const it_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi contribuire solo una volta`)
};

const ja_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`貢献は一度のみ可能です`)
};

const ko_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`기부는 딱 한 번만 가능해요`)
};

const pt_br_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você só pode contribuir uma vez!`)
};

const ru_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете внести вклад только раз`)
};

const th_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสามารถมีส่วนร่วมได้เพียงแค่ครั้งเดียวเท่านั้น`)
};

const tr_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca bir kez katkıda bulunabilirsin`)
};

const zh_cn_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只能进行一次捐献`)
};

const zh_tw_earth_day_2025_donate_plan_note = /** @type {(inputs: Earth_Day_2025_Donate_Plan_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`只能進行一次捐獻`)
};

/**
* | output |
* | --- |
* | "You can only contribute once" |
*
* @param {Earth_Day_2025_Donate_Plan_NoteInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_donate_plan_note = /** @type {((inputs?: Earth_Day_2025_Donate_Plan_NoteInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Donate_Plan_NoteInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_donate_plan_note(inputs)
	if (locale === "ar") return ar_earth_day_2025_donate_plan_note(inputs)
	if (locale === "de") return de_earth_day_2025_donate_plan_note(inputs)
	if (locale === "es") return es_earth_day_2025_donate_plan_note(inputs)
	if (locale === "fr") return fr_earth_day_2025_donate_plan_note(inputs)
	if (locale === "it") return it_earth_day_2025_donate_plan_note(inputs)
	if (locale === "ja") return ja_earth_day_2025_donate_plan_note(inputs)
	if (locale === "ko") return ko_earth_day_2025_donate_plan_note(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_donate_plan_note(inputs)
	if (locale === "ru") return ru_earth_day_2025_donate_plan_note(inputs)
	if (locale === "th") return th_earth_day_2025_donate_plan_note(inputs)
	if (locale === "tr") return tr_earth_day_2025_donate_plan_note(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_donate_plan_note(inputs)
	return zh_tw_earth_day_2025_donate_plan_note(inputs)
});